import styled from '@emotion/styled';
import {sizes} from 'patient-ping-remedy/packages/theme';

const Wrapper = styled.div`
  padding: ${sizes.large};
`;

export default Wrapper;
